import React, { useState, useEffect, useContext } from 'react'
import Layout from '../Layout'
import CheckoutComponent from '../../../utils/CommonFunctionality/Checkout/'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Checkout = (props) => {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? <SEOTAG page="Checkout" /> : null}
            <Layout props={props}>
                <CheckoutComponent props={props} />
            </Layout>
        </>
    )
}

export default Checkout
